var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgActiveDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 8,
    viewBox: "0 0 10 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.00014 1.39023C1.00014 1.29551 1.0311 1.21263 1.09303 1.14159C1.21688 0.999512 1.41298 0.999512 1.52651 1.14159L5.21115 5.36847L8.92675 1.10607C9.0506 0.963992 9.2467 0.963992 9.36024 1.10607C9.48409 1.24815 9.48409 1.47311 9.36024 1.60335L5.21115 6.36303L1.09303 1.65071C1.0311 1.57967 1.00014 1.48495 1.00014 1.39023Z",
    fill: "white",
    stroke: "#F22B5D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveDown);
export default __webpack_public_path__ + "static/media/activeDown.11954292af763731773543f7dbf74522.svg";
export { ForwardRef as ReactComponent };